import { SignageMediaType } from '../../types/signage';

const EXTENSION_BY_TYPE: Record<string, string> = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/gif': 'gif',
  'video/mp4': 'mp4',
  'video/webm': 'webm',
};

/** The name to save a media file under: its uploaded name, or the title plus an extension from its type. */
export const mediaDownloadName = (fileName: string | undefined, title: string, blobType: string, mediaType: SignageMediaType): string => {
  if (fileName) return fileName;
  const base = title.trim().replace(/[\\/:*?"<>|]+/g, '_') || 'media';
  const extension = EXTENSION_BY_TYPE[blobType] ?? (mediaType === 'video' ? 'mp4' : mediaType === 'gif' ? 'gif' : 'png');
  return `${base}.${extension}`;
};

/** Saves a blob through the browser's download, without leaving the page. */
export const saveBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
